import React from 'react';
import {
  Body3,
  Box,
  Color,
  Display,
  FlexDirection,
  FontSize,
  Join,
  JustifyContent,
  Link,
  ResponsiveValue,
  Space,
  TextAlign,
} from '@gousto-internal/citrus-react';
import { InternalLink } from '../../InternalLink/InternalLink';

export function FootnotesSection({
  shouldShowDiscountFootnote,
  shouldShowPriceUpdateFootnote = false,
}: {
  shouldShowDiscountFootnote: boolean;
  shouldShowPriceUpdateFootnote?: boolean;
}) {
  const linkSize: ResponsiveValue<FontSize> = [0, null, 2];

  return (
    <section aria-label="footnotes-section">
      <Box
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        justifyContent={JustifyContent.Center}
        bg={Color.White}
        paddingV={12}
        paddingH={[4, null, 10]}
      >
        <Join with={<Space size={4} />}>
          <Body3 textAlign={TextAlign.Center} id="irish-meat-footnote">
            {
              '* Our “Best value recipe box” claim is based on Gousto having the lowest price across comparable box sizes in Ireland versus HelloFresh and DropChef, including standard delivery fees, excluding discounts, offers and premium recipe surcharges. '
            }
            <Link size={linkSize} href="https://cook.gousto.ie/value/">
              Compare Value
            </Link>
          </Body3>

          <Body3 textAlign={TextAlign.Center} id="irish-meat-footnote">
            ** Reared and packed in Northern Ireland.
          </Body3>

          <Body3 textAlign={TextAlign.Center} id="carbon-footprint-footnote">
            † Click to verify our{' '}
            <Link
              size={linkSize}
              href="https://cook.gousto.co.uk/carbon-footprint-comparison/"
              target={'_blank'}
              rel={'noopener noreferrer'}
            >
              carbon footprint claims
            </Link>
          </Body3>

          {shouldShowDiscountFootnote && (
            <Body3 textAlign={TextAlign.Center} id="discount-footnote">
              ‡ New customers only.{' '}
              <InternalLink href="/terms-and-conditions">
                <Link size={linkSize}>Standard T&Cs apply.</Link>
              </InternalLink>{' '}
              Not including additional charges. Offer may only be claimed once and applies to the
              account you are logged into. Once discount is claimed, the relevant discount will be
              applied to your first order and subsequent discount to all following orders delivered
              within 60 days. This offer cannot be used in conjunction with other offers.
            </Body3>
          )}

          {shouldShowPriceUpdateFootnote && (
            <Body3 textAlign={TextAlign.Center} id="price-update-footnote">
              § €3.99 Based on price per portion on a 5 x 4 subscription box. Excl. €4.99 delivery
              fee. €2.00 based on new customer price per portion on a 5 x 4 subscription box.
            </Body3>
          )}
        </Join>
      </Box>
    </section>
  );
}
